var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.antdLocale}},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"type_container"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }